// extracted by mini-css-extract-plugin
export default {"container":"Name_container__POZni","content":"Name_content__UOxc8","textContainer":"Name_textContainer__IUXV6"};